// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/activities/';
export const actions = [
  'SET_ACTIVITIES',
  'SET_ACTIVITY_CATEGORIES',
  'SET_ACTIVITY_DEFAULT_DATES'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});


// Reducer

export default function reducer (
  state={},
  action={}
) {
  switch(action.type) {
    case actions.SET_ACTIVITIES:
      return {
        ...state,
        allActivities: action.payload.activities
      };
    case actions.SET_ACTIVITY_CATEGORIES:
      return {
        ...state,
        categories: {...state.categories, ...action.payload.categories}
      };
    case actions.SET_ACTIVITY_DEFAULT_DATES:
      return {
        ...state,
        defaultDates: action.payload.defaultDates
      };

    default:
      return state;
  }
}

// Action Creators

export const setActivities = ({ activities }) => {
  return {
    type: actions.SET_ACTIVITIES,
    payload: { activities }
  };
};

export const setActivityCategories = ({ categories }) => {
  return {
    type: actions.SET_ACTIVITY_CATEGORIES,
    payload: { categories }
  };
};

export const setActivityDefaultDates = (defaultDates) => {
  return {
    type: actions.SET_ACTIVITY_DEFAULT_DATES,
    payload: { defaultDates }
  };
};
